import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "about" */ '../views/home/index.vue'),
    meta: {
      title: '山东昱晟玻璃制品有限公司'
    },
  },

  {
    path: '/about/index',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/about/index.vue'),
    meta: {
      title: '山东昱晟玻璃制品有限公司'
    },

  },
  {
    path: '/contact/index',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/contact/index.vue'),
    meta: {
      title: '山东昱晟玻璃制品有限公司'
    }
  },

  {
    path: '/technology/index',
    name: 'Technology',
    component: () => import(/* webpackChunkName: "about" */ '../views/technology/index.vue'),
    meta: {
      title: '山东昱晟玻璃制品有限公司'
    }
  },

  {
    path: '/product/kerongxianwei',
    name: 'kerongxianwei',
    component: () => import(/* webpackChunkName: "about" */ '../views/product/kerongxianwei.vue'),
    meta: {
      title: '山东昱晟玻璃制品有限公司'
    }
  },


  {
    path: '/product/namijuereban',
    name: 'namijuereban',
    component: () => import(/* webpackChunkName: "about" */ '../views/product/namijuereban.vue'),
    meta: {
      title: '山东昱晟玻璃制品有限公司'
    }
  },

  {
    path: '/product/taocixianwei',
    name: 'taocixianwei',
    component: () => import(/* webpackChunkName: "about" */ '../views/product/taocixianwei.vue'),
    meta: {
      title: '山东昱晟玻璃制品有限公司'
    }
  },
  {
    path: '/product/qita',
    name: 'qita',
    component: () => import(/* webpackChunkName: "about" */ '../views/product/qita.vue'),
    meta: {
      title: '山东昱晟玻璃制品有限公司'
    }
  },
  {
    path: '/detail/index',
    name: 'detail',
    component: () => import(/* webpackChunkName: "about" */ '../views/detail/index.vue'),
    meta: {
      title: '山东昱晟玻璃制品有限公司'
    }
  },
  {
    path: '/product/list',
    name: 'productList',
    component: () => import(/* webpackChunkName: "about" */ '../views/product/list.vue'),
    meta: {
      title: '山东昱晟玻璃制品有限公司'
    }
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
router.beforeEach((to, from, next) => {
  to.meta.title && (document.title = to.meta.title);
  next()
});
export default router
